<div class="p-6 max-w-7xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-lg font-bold text-vivid-royal-800 dark:text-white">Videos Tutoriales</h1>
    <p class="text-sm text-vivid-royal-400 mt-1">Aprende a utilizar las funciones del portal con estos videos guía.</p>
  </div>

  <div class="flex flex-col lg:flex-row gap-6">

    <!-- Video player -->
    <div class="lg:flex-1">
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm overflow-hidden">
        @if(actualVideo) {
          <div class="aspect-video bg-black">
            <video class="w-full h-full" #videoPlayer controls autoplay>
              <source [src]="'./assets/videos/medios/' + actualVideo.src" type="video/mp4" />
              Tu navegador no soporta video
            </video>
          </div>
          <div class="p-4">
            <h2 class="text-base font-semibold text-vivid-royal-700 dark:text-white">{{ actualVideo.title }}</h2>
            @if(actualVideo.description) {
              <p class="text-sm text-vivid-royal-400 mt-1">{{ actualVideo.description }}</p>
            }
          </div>
        }
      </div>
    </div>

    <!-- Playlist -->
    <div class="lg:w-80 flex-shrink-0">
      <div class="bg-white dark:bg-crayola-blue-800 rounded-xl shadow-sm overflow-hidden">
        <div class="px-4 py-3 border-b border-dark-khaki-200 dark:border-vivid-royal-700">
          <p class="text-xs font-semibold text-vivid-royal-500 dark:text-vivid-royal-300 uppercase tracking-wide">
            <i class="pi pi-list mr-1"></i> Playlist · {{ videos.length }} videos
          </p>
        </div>
        <div class="max-h-[500px] overflow-y-auto">
          @for(video of videos; track video.id) {
            <div class="flex items-center gap-3 px-4 py-3 cursor-pointer transition-colors"
              [ngClass]="actualVideo?.id === video.id
                ? 'bg-vivid-royal-50 dark:bg-vivid-royal-900 border-l-3 border-vivid-royal-500'
                : 'hover:bg-dark-khaki-50 dark:hover:bg-vivid-royal-900/50'"
              (click)="selectVideo(video)">

              <!-- Thumbnail -->
              <div class="w-24 h-14 flex-shrink-0 rounded-lg overflow-hidden relative bg-vivid-royal-900">
                <img [src]="'./assets/videos/' + video.thumbnail" class="w-full h-full object-cover" />
                <div class="absolute inset-0 bg-black/30 flex items-center justify-center">
                  @if(actualVideo?.id === video.id) {
                    <i class="pi pi-pause-circle text-white text-xl"></i>
                  } @else {
                    <i class="pi pi-play-circle text-white text-xl"></i>
                  }
                </div>
              </div>

              <!-- Info -->
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium truncate"
                  [ngClass]="actualVideo?.id === video.id
                    ? 'text-vivid-royal-600 dark:text-vivid-royal-200'
                    : 'text-vivid-royal-700 dark:text-vivid-royal-300'">
                  {{ video.title }}
                </p>
                <p class="text-xs text-vivid-royal-400 mt-0.5">Video {{ $index + 1 }} de {{ videos.length }}</p>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

  </div>
</div>
